import { AnchorBehavior, ConsentsLedger, LegalConsent, OnConsentChange } from '../LegalConsents.types';

export type LinkBehavior = 'accordion' | 'newTab' | 'default';

export interface ConsentsListProps {
  consentState: ConsentsState;
  validateErrors: boolean;
  onConsentChange: OnConsentChange;
  anchorBehavior: AnchorBehavior;
  linkBehavior: LinkBehavior;
  closeAccordionBtnLabel: string | null;
  openAccordionBtnLabel: string | null;
}

export enum ConsentErrorType {
  NONE = 'none',
  NO_ENTRIES_FOUND = 'noEntriesFound',
  INVALID_RESPONSE = 'invalidResponse',
  UXL_API_FAILURE = 'uxlApiFailure',
  INTERNAL_VALIDATION_ERROR = 'internalValidationError',
  ALL_REQUIRED_CONSENTS_NOT_SELECTED = 'allRequiredConsentsNotSelected',
  ALL_ATOMIC_CONSENTS_NOT_SELECTED = 'allAtomicConsentsNotSelected',
  MULTIPLE_VAILDATION_FAILED = 'multipleValidationFailed',
}

export interface ConsentError {
  type: ConsentErrorType;
  message: string | null;
}

export interface ErrorBannerProps {
  consentsState: ConsentsState;
  className?: string | null;
}

export type ConsentsSectionTypes = Record<string, unknown>;

export interface ConsentsState {
  list: LegalConsent[];
  sectionTypes: ConsentsSectionTypes;
  consentsLedger: ConsentsLedger;
  error: ConsentError;
  loading?: boolean;
}

export type ConsentsCheckListModalInfo = {
  showModal: boolean;
  href: string;
};
